import { createContext as k } from "preact";
import { useContext as C, useMemo as T, useCallback as g } from "preact/hooks";
import { b as S, u as I, a as f, d as y, m as M } from "./unique-Cv2g464w.js";
import { i as w, l as U } from "./logger-_fg_Za9y.js";
import { s as q } from "./search-sC5QgJmw.js";
const E = k(null), Q = () => {
  const e = C(E);
  if (!e)
    throw new Error("useConfig must be used within a ConfigProvider");
  return e;
};
function z(e, r = {}) {
  const t = /* @__PURE__ */ new Map();
  let i = S(e, r ?? {});
  const o = S(e, r);
  function c(d) {
    i = d(i);
    for (const u of t.values())
      u(i);
  }
  function n(d) {
    c((u) => ({ ...u, ...d }));
  }
  function s() {
    return i;
  }
  function a() {
    return structuredClone(o);
  }
  function l(d, u) {
    let m;
    t.set(u, (P) => {
      const p = d(P);
      w(p, m) || (m = p, u(p));
    });
  }
  function v(d) {
    l(
      (u) => u.initialized,
      (u) => {
        u && d();
      }
    );
  }
  function F(d) {
    t.delete(d);
  }
  return {
    updateState: n,
    getState: s,
    getInitialState: a,
    onChange: l,
    onInit: v,
    clearOnChange: F
  };
}
const A = {
  loading: !0,
  query: {},
  response: {},
  initialized: !1
};
function K(e = {}) {
  return z(A, e);
}
const B = k(K());
function D(e, r) {
  return {
    ...r,
    products: {
      facets: e === "autocomplete" ? void 0 : ["*"],
      fields: L,
      ...r.products
    },
    ...r.keywords ? {
      keywords: {
        ...r.keywords,
        fields: I([...O, ...r.keywords.fields ?? []]),
        highlight: r.keywords.highlight ?? {
          preTag: "<strong>",
          postTag: "</strong>"
        }
      }
    } : {}
  };
}
const L = [
  "productId",
  "url",
  "name",
  "imageUrl",
  "imageHash",
  "thumbUrl",
  "description",
  "brand",
  "variantId",
  "availability",
  "price",
  "priceText",
  "categoryIds",
  "categories",
  "customFields.key",
  "customFields.value",
  "priceCurrencyCode",
  "datePublished",
  "listPrice",
  "unitPricingBaseMeasure",
  "unitPricingUnit",
  "unitPricingMeasure",
  "googleCategory",
  "gtin",
  "ageGroup",
  "gender",
  "condition",
  "alternateImageUrls",
  "ratingValue",
  "reviewCount",
  "inventoryLevel",
  "skus.id",
  "skus.name",
  "skus.price",
  "skus.listPrice",
  "skus.priceText",
  "skus.url",
  "skus.imageUrl",
  "skus.inventoryLevel",
  "skus.customFields.key",
  "skus.customFields.value",
  "skus.availability",
  "pid",
  "onDiscount",
  "extra.key",
  "extra.value",
  "saleable",
  "available",
  "tags1",
  "tags2",
  "tags3"
], O = ["keyword", "_redirect"];
async function b(e, r, t) {
  const i = f("newSearch"), o = e.config.pageType, c = o === "search" ? "serp" : o, n = y(e.store.getInitialState().query, r), s = y(e.config.search, t, {
    track: c,
    redirect: o !== "autocomplete",
    isKeyword: !!t?.isKeyword,
    usePersistentCache: e.config.pageType !== "autocomplete" && e.config.persistentSearchCache,
    useMemoryCache: e.config.pageType === "autocomplete" && e.config.memoryCache
  });
  e.config.onBeforeSearch?.(e, s), e.store.updateState({
    query: n,
    loading: !0,
    initialized: !0
  });
  const a = e.config.queryModifications(
    {
      ...n,
      products: {
        ...n.products,
        // Apply filter merging to avoid overwriting base filters
        filter: M(e.store.getInitialState().query?.products?.filter, r.products?.filter)
      }
    },
    o
  );
  try {
    const l = await q(D(e.config.pageType, a), s);
    e.store.updateState({
      response: l,
      loading: !1
    });
  } catch (l) {
    U.error("Search action failed", l), e.config.onSearchError?.(l, a, s, o);
  }
  i();
}
async function h(e, r, t) {
  const i = f("updateSearch"), o = y(e.store.getState().query, { products: { from: 0 } }, r);
  await b(e, o, t), i();
}
async function V(e, r, t) {
  const i = f("replaceFilter"), o = e.store.getState().query.products?.filter, c = t !== void 0 ? [{ field: r, [typeof t == "object" ? "range" : "value"]: [t] }] : [];
  await h(e, {
    products: {
      filter: [...o?.filter((n) => n.field !== r) ?? [], ...c]
    }
  }), i();
}
async function j(e, r, t, i) {
  const o = f("toggleProductFilter"), c = e.store.getState().query.products?.filter, n = c?.find((a) => a.value instanceof Array && a.field === r), s = n?.value ? {
    ...n,
    value: [...n.value.filter((a) => !w(a, t)), ...i ? [t] : []]
  } : i ? {
    field: r,
    value: [t]
  } : void 0;
  await h(e, {
    products: {
      filter: [...c?.filter((a) => a !== n) ?? [], ...s?.value?.length ? [s] : []]
    }
  }), o();
}
function R() {
  const e = Q(), r = C(B), t = T(
    () => ({
      config: e,
      store: r
    }),
    [e, r]
  ), i = g(
    (s, a) => b(t, s, a),
    [t]
  ), o = g(
    (s, a) => h(t, s, a),
    [t]
  ), c = g(
    (s, a, l) => j(t, s, a, l),
    [t]
  ), n = g(
    (s, a) => V(t, s, a),
    [t]
  );
  return {
    newSearch: i,
    updateSearch: o,
    toggleProductFilter: c,
    replaceFilter: n
  };
}
export {
  E as C,
  B as S,
  Q as a,
  z as b,
  K as c,
  A as d,
  R as e,
  b as n,
  h as u
};
